import { LOCALES } from 'shared/enums/Localization';
import { getLocale } from 'shared/utils/getLocale';
import dayjs from 'dayjs';

export const DATE_FORMATS: any = {
  [LOCALES.enUS]: {
    YYYYMMDD: 'YYYYMMDD',
    'MMM DD': 'MMM DD',
    'MMMM DD': 'MMMM DD',
    'MMMM YYYY': 'MMMM YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'MMM DD YYYY': 'MMM DD YYYY',
    'MM/DD': 'MM/DD',
    'h:mm A': 'h:mm A',
  },
  [LOCALES.frFR]: {
    YYYYMMDD: 'D MMM YYYY',
    'MMM DD': 'D MMM',
    'MMMM DD': 'D MMMM',
    'MMMM YYYY': 'MMMM YYYY',
    'MM-DD-YYYY': 'D MM YYYY',
    'MMM DD YYYY': 'D MMM YYYY',
    'MM/DD': 'DD/MM',
    'h:mm A': 'HH[h]mm',
  },
};

export const localizeDate = (format: string) => {
  const locale = getLocale();
  return DATE_FORMATS?.[locale]?.[format] || format;
};

const formatDateStr = (dateStr: string | number, dateFormat: string, locale?: string) => {
  if (!dateStr) return '';
  if (locale) {
    return dayjs(dateStr).locale(locale).format(dateFormat);
  }
  return dayjs(dateStr).format(dateFormat);
};

// Format's date string using dayjs format
// Formatting options: https://day.js.org/docs/en/display/format
export const formatDate = {
  monthDayYearKebab: (dateStr: string) => formatDateStr(dateStr, localizeDate('MM-DD-YYYY')),
  monthDay: (dateStr: string) => formatDateStr(dateStr, localizeDate('MMMM DD')),
  monthDayYear: (dateStr: string) => formatDateStr(dateStr, localizeDate('MMMM DD, YYYY')),
  monthYear: (dateStr: any) => formatDateStr(dateStr, localizeDate('MMMM YYYY')),
  monthYearEN: (dateStr: string) => formatDateStr(dateStr, 'MMMM YYYY', 'en'),
  time: (dateStr: string) => formatDateStr(dateStr, localizeDate('h:mm A')),
  year: (dateStr: string) => formatDateStr(dateStr, localizeDate('YYYY')),
  yearMonth: (dateStr: string) => formatDateStr(dateStr, localizeDate('YYYYMM')),
  yearMonthDay: (dateStr: string) => formatDateStr(dateStr, localizeDate('YYYYMMDD')),
};
